import { createNavigationContainerRef } from "@react-navigation/native";
import type { RootStackParamList } from "./Navigation";

// Create the navigation ref
export const navigationRef = createNavigationContainerRef<RootStackParamList>();

// Global navigate function
export function navigateGlobal<RouteName extends keyof RootStackParamList>(
  name: RouteName,
  params?: RootStackParamList[RouteName],
) {
  if (navigationRef.isReady()) {
    // @ts-expect-error
    navigationRef.navigate(name, params);
  } else {
    console.warn("Navigation is not ready yet.");
  }
}
